import * as React from "react";
export function useDialogClose(enabled, callback) {
    const callbackRef = React.useRef(callback);
    const firstRenderRef = React.useRef(true);
    React.useEffect(() => {
        if (firstRenderRef.current) {
            firstRenderRef.current = false;
            return;
        }
        const cb = callbackRef.current;
        return () => {
            if (enabled)
                cb();
        };
    }, [enabled]);
}
//# sourceMappingURL=use-dialog-close.js.map